import { combineReducers } from 'redux';
import fragment from './fragment';
import route from './route';
import style from './style';
import control from './control';

function lastAction(state = null, action) {
    return action;
}

const rootReducer = combineReducers({
    lastAction,
    fragment,
    route,
    style,
    control,
});

export default rootReducer;
